import clsx from 'clsx';
import {
  type ElementType,forwardRef, type HTMLAttributes, type ReactNode
} from 'react';

import styles from './typography.module.scss';

export interface HeadingProps extends Omit<HTMLAttributes<HTMLHeadingElement>, 'as'> {
  /**
   * The semantic level of the heading (h1-h6)
   * Default: h1
   */
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  /**
   * Font size variant
   * Default: lg (26px)
   */
  size?: 'lg' | 'md' | 'sm';
  children?: ReactNode;
}

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  (
    {
      as = 'h1',
      size = 'lg',
      children,
      className,
      ...props
    },
    ref
  ) => {
    const Tag = as as ElementType;

    const headingClasses = clsx(
      styles.heading,
      styles[`heading--${ size }`],
      className
    );

    return (
      <Tag
        ref={ ref }
        className={ headingClasses }
        { ...props }
      >
        {children}
      </Tag>
    );
  }
);

Heading.displayName = 'Heading';
